import { useState } from 'react';
import apiClient from '../../../Services/ApiClient';
import { ItemScheme } from '../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../Enums/MagicField.enum';

export default function useBillingAddressContainer() {
	const [isLoading, setIsLoading] = useState(false);
	const billingAddressContainerScheme = async () => {
		setIsLoading(true);
		const formScheme: ItemScheme[] = [];
		const address = await apiClient.get(
			'/wizard/billingAddressContainer/tree',
			{},
		);

		if (address?.data) {
			const addressFields: ItemScheme[] = [];
			address.data.forEach((item: any) => {
				addressFields.push(item);
			});

			formScheme.push({
				type: MagicField.CONTAINER,
				key: 'billingAddress',
				children: addressFields,
			});
		}
		setIsLoading(false);
		return formScheme;
	};

	const addToBillingAddressContainer = async (
		formScheme: ItemScheme[],
	): Promise<ItemScheme[]> => {
		setIsLoading(true);

		const address = await apiClient.get(
			'/wizard/billingAddressContainer/tree',
			{},
		);
		const addressFields: ItemScheme[] = address?.data ?? [];

		const updateFormScheme = (items: ItemScheme[]): ItemScheme[] => {
			return items.map(item => {
				if (item.key === 'billingAddress') {
					return {
						...item,
						children: addressFields,
					};
				}

				if (item.children) {
					return {
						...item,
						children: updateFormScheme(item.children as ItemScheme[]),
					};
				}

				return item;
			});
		};

		const updated = updateFormScheme(formScheme);
		setIsLoading(false);
		return updated;
	};

	return {
		billingAddressContainerScheme,
		addToBillingAddressContainer,
		isLoading,
	};
}
